const t = {
  name: "Lock3",
  dimensions: { width: 24, height: 24 },
  content: `
<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M13 13V18H11V13H13Z" fill="currentColor"/>
<path d="M7 8V6C7 3.23772 9.23771 1 12 1C14.7623 1 17 3.23772 17 6V8H23V12C23 18.0723 18.0723 23 12 23C5.92772 23 1 18.0723 1 12V8H7ZM9 6V8H15V6C15 4.34228 13.6577 3 12 3C10.3423 3 9 4.34228 9 6ZM3 10V12C3 16.9677 7.03228 21 12 21C16.9677 21 21 16.9677 21 12V10H3Z" fill="currentColor"/>
</svg>
  `
};
export {
  t as Lock3
};
